export default `# Teams

Teams organise members for collaboration and task assignment. View your teams, check membership, and track active work.

---

## Team Overview

The page shows all teams as cards in a responsive grid. Each card displays:
- **Team name** and description
- **Member count** — How many people are on the team
- **Active Tasks** — Current work items assigned to the team

Use the **search bar** to find teams by name. Toggle **Show Archived** to see or hide archived teams.

---

## Team Detail

Click any team card to view its detail page, where you can:
- See the full member list with roles
- View and manage tasks assigned to the team
- Check team permissions and access levels

---

## Creating Teams

Click **Create Team** (system admin only) to set up a new team. Define the team name, description, and initial members.

---

## Team Lifecycle

- **Active** — Team is in use, members can collaborate
- **Archived** — Team is hidden from the default view but can be restored

---

## Tips

- **Use teams for recurring project groups** — Assign the same team to multiple projects for consistent collaboration
- **Check active task counts** — Teams with many active tasks may need additional members
- **Archive instead of deleting** — Archived teams preserve their history and can be reactivated`;
